import postsLoadMore from "../components/postsLoadMore";

export default () => {
    postsLoadMore();

    let filterModal = document.querySelector('.filter-modal');
    let filterForm = document.getElementById('newsFilterForm');
    let categoryInput = filterForm.querySelector('[name=category]');
    let filterCheckboxes = filterModal.querySelectorAll('.filter-checkbox');
    let submitButton = document.getElementById('submitBtn');
    let clearButton = document.getElementById('clearBtn');
    let modalTrigger = document.querySelector(".filter-type");
    let closeBtn = document.querySelector(".close-modal");
    let categoriesString = '';

    submitButton.addEventListener('click', function () {
        categoriesString = '';
        filterCheckboxes.forEach((item) => {
            if (item.checked === true) {
                if (categoriesString === '') {
                    categoriesString = item.value;
                } else {
                    categoriesString += ',' + item.value;
                }
            }

        });
        categoryInput.value = categoriesString;
        filterForm.submit();
    });

    clearButton.addEventListener('click', function () {
        filterCheckboxes.forEach((item) => {
            item.checked = false;
        });
        categoryInput.value = '';
        // filterForm.submit();
        closeModal();
    });

    modalTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        openModal()
    });

    closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeModal();
    });

    function openModal() {
        let filterBlock = document.querySelector(".filter-modal");
        let filterWrap = document.querySelector(".filter-content-wrapper");
        let shadow = document.querySelector(".shadow");
        filterBlock.classList.add('show');
        shadow.style.display = "block";
        filterWrap.classList.remove("reverse-arrow");
    }

    function closeModal() {
        let filterBlock = document.querySelector(".filter-modal");
        let filterWrap = document.querySelector(".filter-content-wrapper");
        let shadow = document.querySelector(".shadow");
        filterBlock.classList.remove('show');
        shadow.style.display = "none";
        filterWrap.classList.add("reverse-arrow");
    }
};